// Function to handle link click
function handleClick(event) {
    // Prevent default link behavior
    event.preventDefault();
    
    // Get the URL of the current page
    var currentUrl = window.location.href;

    // Remove existing parameters
    var urlWithoutParams = currentUrl.split('?')[0];
    
    // Get the filter value from the data attribute without decoding
    var filterValue = event.target.dataset.filterValue;
    
    // Construct the new URL with the filter parameter
    var newUrl = urlWithoutParams + '?filter.p.tag=' + filterValue;

    // Change the URL without reloading the page
    sessionStorage.setItem('scrollPosition', window.scrollY);
    window.location.href = newUrl;
}

// Attach click event listener to the document and delegate it to elements with the class filterCollection
document.addEventListener('click', function(event) {
    if (event.target.matches('.filterCollection') || event.target.closest('.filterCollection')) {
        handleClick(event);
    }
});

// Function to scroll to the heading after page reload
document.addEventListener('DOMContentLoaded', function() {
    var currentUrl = window.location.href;

    if (currentUrl.includes('filter')) {
        var heading = document.querySelector('.scroll-anchor');
        if (heading) {
            heading.scrollIntoView();
        }
    }
});

// Function to handle adding multiple parameters at the same time
function addMultipleParameters(params) {
    // Get the URL of the current page
    var currentUrl = window.location.href;

    // Remove existing parameters
    var urlWithoutParams = currentUrl.split('?')[0];

    // Construct the new URL with multiple filter values
    var newUrl = urlWithoutParams + '?' + params;

    // Change the URL without reloading the page
    window.location.href = newUrl;
}

function hideDetailsOnMobile() {
    // Check if the screen width is less than or equal to 768px
    if (window.innerWidth <= 768) {
        // Get all summary elements
        const summaryElements = document.querySelectorAll('details summary');

        // Iterate through summary elements to find the ones containing the text "Packaging" or "Brand"
        summaryElements.forEach(summary => {
            const summaryText = summary.textContent;
            if (summaryText.includes('Packaging') || summaryText.includes('Brand')) {
                // Hide the parent details element if found
                summary.parentElement.style.display = 'none';
            }
        });
    }
}

// Call the function initially
hideDetailsOnMobile();

// Add event listener to re-evaluate when the screen size changes
window.addEventListener('resize', hideDetailsOnMobile);